import { render, staticRenderFns } from "./NewsUpdates.vue?vue&type=template&id=2674df1e&scoped=true"
import script from "./NewsUpdates.vue?vue&type=script&lang=js"
export * from "./NewsUpdates.vue?vue&type=script&lang=js"
import style0 from "./NewsUpdates.vue?vue&type=style&index=0&id=2674df1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674df1e",
  null
  
)

export default component.exports